import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']
  static values = {
    plural: String,
    empty: String
  }

  update() {
    const checked = this.element.querySelectorAll('input[type="checkbox"][name]:checked').length
    const text = checked === 0
      ? this.emptyValue
      : this.pluralValue.replace('%{count}', checked)

    const label = this.buttonTarget.querySelector(':scope > span') || this.buttonTarget
    label.textContent = text
  }
}
